export const useUpdtPassword = () => {

    const updtPassword = async (_id, data, password) => {        
        const req = await fetch(`https://api.pro-vide.eu/user/edit-pw/${_id}`, {
            method: 'put',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ password: password, new_password: data.new_pw })
        });
        
        const res = await req.json();
        
        if (req.status !== 200) {
            return res.message
        }

        return res
    };

    return updtPassword;
};